import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Result, Button, Modal, Input } from 'antd';
import campaignLinkRequestService from "../../../../services/campaignLinkRequestService";
import { useIsMobile } from "../../../../utils/helpers";

const { TextArea } = Input;

const CampaignRequestRejectPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [open, setOpen] = useState(true);
    const [reason, setReason] = useState('');
    const [status, setStatus] = useState<'success' | 'error' | null>(null);
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const isMobile = useIsMobile(); // ✅ same pattern

    const handleReject = async () => {
        if (!id) return;

        try {
            const res = await campaignLinkRequestService.rejectRequest(id, {
                rejectionReason: reason
            });

            setStatus('success');
            setMessage(res.data.message || 'Request rejected successfully');
        } catch (e: any) {
            setStatus('error');
            setMessage(e?.response?.data?.message || 'Failed to reject request');
        } finally {
            setOpen(false);
        }
    };

    if (status) {
        return (
            <div
                style={{
                    maxWidth: 600,
                    margin: '0 auto',
                    padding: 16,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '70vh'
                }}
            >
                <Result
                    status={status}
                    title={status === 'success' ? 'Request Rejected' : 'Error'}
                    subTitle={message}
                    extra={[
                        <Button
                            key="backToRequests"
                            type="primary"
                            block={isMobile}
                            onClick={() => navigate('/campaign-requests')}
                        >
                            Back to requests
                        </Button>
                    ]}
                />
            </div>
        );
    }

    return (
        <Modal
            open={open}
            title="Reject request"
            onOk={handleReject}
            onCancel={() => navigate('/campaign-requests')}
            width={isMobile ? '100%' : 500}
            style={isMobile ? { top: 0, padding: 0 } : {}}
            bodyStyle={{ padding: 16 }}
            okButtonProps={{ block: isMobile }}
            cancelButtonProps={{ block: isMobile }}
        >
            <TextArea
                rows={4}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Optional reason"
                style={{ marginTop: 8 }}
            />
        </Modal>
    );
};

export default CampaignRequestRejectPage;